import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Overlay, Popover, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchAllOrgsData, selectAllOrgs, } from "../../redux/actions/getAllOrgsAction";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../API/axios";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";


const UpdateAward = ({ getUserCv, handleCloseUpdateAward, showUpdateAward, userDataId, awardData }) => {
  const dispatch = useDispatch();


  // update Award ..... 

  const [industryDataId, setIndustryDataId] = useState(null);

  useEffect(() => {
    if (awardData) {
      setOrgType(awardData?.orgType);
      setGetAllOrgsId(awardData?.orgId);
      setAwardname(awardData?.name)
      setRecognition(awardData.recognition)
      setIsUseDate(awardData?.issueDate);
      setDescription(awardData?.description);
      setCitySearch(awardData?.cityId);

    }
  }, [awardData]);


  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();

  const [isPresent, setIsPresent] = useState(false);
  const [description, setDescription] = useState("");
  const [awardname, setAwardname] = useState("");
  const [recognition, setRecognition] = useState("");
  const [isuseDate, setIsUseDate] = useState("");
  const [OrgName, setOrgName] = useState("");

  const [display, setDisplay] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      issuerOrgType: getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,
      orgID: orgType === '' || orgType === 0 ? neworgType : orgType,
      name: awardname,
      recognition: recognition,
      issueDate: moment(isuseDate).format("YYYY-MM-DD"),
      description: description,
      cityId: citySearch,
      awrdId: awardData.usrDataAwrdId

    };
    console.log("body", body);

    if (awardname === '' || recognition === '' || isuseDate === '' || description === '' || orgType === '') {
      toast.error('Please fill all the required fields')
    } else {
      try {
        const res = await
          axios.post("/Resume/UpdateAward", body,
            {
              validateStatus: (status) => status >= 200 && status < 300, // Treat only 200-299 as success
            });

        console.log("res=====>", res);

        toast.success(res.data.message);
        handleCloseUpdateAward();
        getUserCv();
        setAwardname();
        setIsUseDate();
        setRecognition();
        setCitySearch();
        setDescription();
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };

  // Create New award

  const [showCreateAward, setShowCreateAward] = useState(false);
  const handleOpenCreateAward = () => setShowCreateAward(true);
  const handleCloseCreateAward = () => setShowCreateAward(false);


  //   Get organization
  const [getallorgsId, setGetAllOrgsId] = useState("");
  const [orgType, setOrgType] = useState("");
  const { getallorgsList, selectedgetallId } = useSelector(
    (state) => state.getallorgs
  );
  useEffect(() => {
    dispatch(fetchAllOrgsData());
  }, [dispatch]);

  const handleOrganization = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectAllOrgs(selectedOption.value));
      setGetAllOrgsId(selectedOption.value);
      setOrgType(selectedOption.tagId)

    }
  };

  console.log('industryDataId', industryDataId, awardData);

  // ...............................City DDL.......................................

  const [orgCity, setOrgCity] = useState(null);
  const [neworgType, setneworgType] = useState('');
  const [neworgId, setneworgId] = useState('');
  const [citySearch, setCitySearch] = useState(null);
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);

  const handleCity = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectCity(selectedOption.value));
      setCitySearch(selectedOption.value);
    }
  };

  const handleCitySelect1 = (selectedOption) => {
    if (selectedOption) {
      setOrgCity(selectedOption.value);
    }
  };


  const [OrganizationName, setOrganizationName] = useState("");
  const [getOrgInsTId, setGenOrgInstId] = useState(null);
  const handleSaveInstitution = async () => {
    // setDisplay(true);

    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdGeneralOrg");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);

    try {
      const res = await axios.post("/CandidateData/AddGnrlOrgData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("res", res);
      // setGenOrgInstId(res.data.responseData);   
      setneworgType(res.data.responseData.value)
      setneworgId(res.data.responseData.id)
      toast.success(res.data.message);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // ...................file selecting............... 

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };

  // ...................toolTip............... 
  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);

  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };


  return (
    <>
      <Modal show={showUpdateAward} onHide={handleCloseUpdateAward} centered size="lg">
        <Modal.Header >
          <Modal.Title>Update Award</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseUpdateAward} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Row>

            <Col md={6}>
              <Form.Group controlId="Awards">
                <Form.Label className="class-type">Award Name{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span></Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={awardname}
                  onChange={(e) => setAwardname(e.target.value)}
                  placeholder="Enter Award name"
                />
                {display && !awardname ? (
                  <span className="error_msg_lbl">Add Project Name </span>
                ) : null}
              </Form.Group>

            </Col>

            {/* Organization */}
            <Col md={6}>

              <Form.Group controlId="addorganization">
                <Form.Group controlId="organization">
                  <Form.Label className="class-type">
                    Organization
                    <span style={{ color: "red" }} className="ms-2">
                      *
                    </span>
                  </Form.Label>
                  {OrgName !== "" ? (
                    <div>
                      <input
                        type="text"
                        value={OrgName}
                        placeholder="Enter Org name"
                        className="mb-2 form-control"
                        disabled
                      />
                    </div>
                  ) : (
                    <div className="post-form-group">
                      <ReactSelect
                        options={getallorgsList}
                        onChange={handleOrganization}
                        value={
                          getallorgsList.find(
                            (option) => option.value === getallorgsId
                          ) || null
                        }
                        placeholder="Select Organization"
                        classNamePrefix="react-select"
                        className="form-control"
                        styles={customStyles}
                      />
                    </div>
                  )}
                </Form.Group>
                <a
                  href="#"
                  ref={targetRef}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTooltip();
                  }}
                  className="createModal"
                // isDisabled={!selectedIndustryId} // Disable until industry is selected
                >
                  Create New
                </a>
                <Overlay
                  target={targetRef.current}
                  show={showTooltip}
                  placement="right"
                  rootClose
                  container={document.querySelector(".modal")}
                  onHide={() => setShowTooltip(false)} // Close when clicking outside
                >
                  <Popover id="popover-basic">
                    <Popover.Header as="h3" className="Dark-Body-Card-group">Create Organization</Popover.Header>
                    <Popover.Body className="Dark-Body-Card-group">
                      <Form>
                        <div>
                          <label className="mb-1 Text-mb-Create">Org name</label>
                          <input
                            type="text"
                            value={OrganizationName}
                            onChange={(e) => {
                              setOrganizationName(e.target.value)
                              setOrgName(e.target.value);

                            }}
                            placeholder="Enter Org name"
                            className="mb-2 form-control Dark-Input-from-group"
                          />
                        </div>

                        <div>
                          <label className="mb-1 Text-mb-Create">City</label>
                          <ReactSelect
                            options={cityList}
                            onChange={handleCitySelect1}
                            value={
                              cityList.find(
                                (option) => option.value === orgCity
                              ) || null
                            }
                            placeholder="Select City"
                            classNamePrefix="react-select"
                            className="form-control Dark-Input-from-group"
                            styles={customStyles}
                          />
                        </div>
                        <div className=" mt-2 mb-2 Text-mb-Create">
                          <label className="mb-1">Org Logo</label>
                          <input
                            type="file"
                            id="lastName"
                            className="form-control Dark-Body-Card-group"
                            placeholder=""
                            onChange={handleFileChange}

                          />

                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              handleSaveInstitution()
                              setShowTooltip(false)
                            }
                            }

                            className="me-2"
                          >
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => setShowTooltip(false)}
                          >
                            Cancel
                          </Button>
                        </div>
                      </Form>
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </Form.Group>
            </Col>

            {/* Recognition */}
            <Col md={6}>

              <Form.Group controlId="recognition">
                <Form.Label className="class-type"> Recognition{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span></Form.Label>
                <Form.Control
                  type="text"
                  className="Dark-Input-from-group"
                  value={recognition}
                  onChange={(e) => setRecognition(e.target.value)}
                  placeholder="Enter Recognition name"
                />
                {display && !recognition ? (
                  <span className="error_msg_lbl">Add Recognition </span>
                ) : null}
              </Form.Group>
            </Col>

            {/* City */}
            <Col md={6}>
              <Form.Group controlId="city">
                <Form.Label className="class-type">
                  City
                  {/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
                </Form.Label>
                <div className="post-form-group">
                  <ReactSelect
                    options={cityList}
                    onChange={handleCity}
                    value={
                      cityList.find(
                        (option) => option.value === citySearch
                      ) || null
                    }
                    placeholder="Select City"
                    classNamePrefix="react-select"
                    className="form-control"
                    styles={customStyles}
                  />
                </div>
                {/* {display && !citySearch ? (
                  <span className="error_msg_lbl">Add City</span>
                ) : null} */}
              </Form.Group>
            </Col>


            {/* Issue Date */}
            <Col md={6}>
              <Form.Group controlId="endYear">
                <Form.Label className="class-type">
                  Issue Date<span className="text-danger ms-2">*</span>
                </Form.Label>
                <Flatpickr
                  type="number"
                  id="issueDate"
                  value={isuseDate}
                  onChange={(date) => setIsUseDate(date[0])}
                  placeholder="Enter Date"
                />
                {display && !isuseDate ? (
                  <span className="error_msg_lbl">Add Date</span>
                ) : null}
              </Form.Group>
            </Col>

          </Row>

          <Row>
            <Col md={12}>
              <Form.Group controlId="description">
                <Form.Label className="class-type">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  id="about"
                  className="Dark-Input-from-group"
                  rows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter Description"
                />
                {display && !description ? (
                  <span className="error_msg_lbl">Add Description  </span>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
          {/* Submit and Close Buttons */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>



      <Modal
        show={showCreateAward}
        onHide={handleCloseCreateAward}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Award</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* Certificate Name */}
            <Col md={12}>
              <div className="post-form-group mb-1">
                <label htmlFor="certificateName">
                  Award Name{" "}
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </label>
                <input type="text" placeholder="Enter certificate name" />
              </div>
            </Col>
          </Row>

          {/* Submit and Close Buttons */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="" onClick={handleSubmit}>
                Save
              </a>
            </div>
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="">
                Close
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UpdateAward